import './search.scss';

class Search {

    constructor(element, options) {

        const settings = {
            breakpoints: null, 
            initAttr: 'data-search', 
            formAttr: 'form', 
            buttonAttr: 'button[type="submit"]', 
            inputAttr: 'input',
            contentClass: 'has--content',
            visibleClass: 'is--visible'
        };

        this.settings = Object.assign({}, settings, options);

        this.$search = element;
        this.$searchForm = this.$search.querySelector(this.settings.formAttr);
        this.$searchButton = this.$search.querySelector(this.settings.buttonAttr);
        this.$searchField = this.$search.querySelector('[' + this.settings.initAttr + '="' + this.settings.inputAttr + '"]');
        this.focusTimeout = null;
        this.instanzId = this.$search.dataset.searchId;

        this.initialize();
    }

    initialize() {
        if (this.instanzId !== undefined) {
            const currentFieldId = this.$searchField.id;
            const adjustedFieldId = currentFieldId + '_' + this.instanzId;

            this.$searchField.setAttribute('id', adjustedFieldId);
            const $searchLabel = this.$searchField.parentElement.querySelector('[data-search="label"]');

            if ($searchLabel) {
                $searchLabel.setAttribute('for', adjustedFieldId);
            }
        }

        this.$searchButton.setAttribute('disabled', true);

        this.$deleteButton = document.createElement('button');
        this.$deleteButton.setAttribute('type', 'button');
        this.$deleteButton.setAttribute('aria-label', window.translations.search.clear_search_label);
        this.$deleteButton.classList.add('search__delete');

        this.$searchField.parentNode.appendChild(this.$deleteButton);
        this.buttonClick = false;
        
        this.setEvents();
    }

    hasContent(bool) {

        if(bool === true) {
            this.$searchButton.removeAttribute('disabled');
            this.$search.classList.add(this.settings.contentClass);
            this.$deleteButton.classList.add(this.settings.visibleClass);
        } else {
            this.$searchButton.setAttribute('disabled', true);

            if(this.$search.classList.contains(this.settings.contentClass)) {
                this.$search.classList.remove(this.settings.contentClass);
            }

            if(this.$deleteButton.classList.contains(this.settings.visibleClass)) {
                this.$deleteButton.classList.remove(this.settings.visibleClass);
            }
        }
    }

    setEvents() {
        this.$searchField.addEventListener('keyup', () => {
            if(this.$searchField.value.length >= 2) {
                this.hasContent(true);
            } else {
                this.hasContent(false);
            }
        });

        this.$deleteButton.addEventListener('click', () => {
            this.$searchField.value = '';
            this.hasContent(false);
        });
    }
}

export default Search;
